/**
 * PipelineActivityLogDrawer — the per-pipeline, manager-facing audit log
 * (SE-5504). Mount once near the board; open it via
 * `usePipelineActivityLogDrawerState().open(boardId)`.
 * @module features/player-kanban/components/organisms/PipelineActivityLogDrawer
 */

export { default } from "./PipelineActivityLogDrawerContainer";
